import React from 'react';
import {
  Box,
  Column,
  Copy,
  Flex,
  Row,
  Square,
} from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { DeprecatedCookbookCheckboxWrapper } from 'src/components/DeprecatedCookbookCheckboxWrapper/DeprecatedCookbookCheckboxWrapper';
import { ParentAdminTableHeaderCell } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/ParentAdminsTable/ParentAdminTableHeaderCell/ParentAdminTableHeaderCell';
import { ParentAdminTableFormProps } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/types';
import { useCookbookSelectAllCheckbox } from 'src/components/enterprise/Parents/Admin/hooks/useCookbookSelectAllCheckbox/useCookbookSelectAllCheckbox';

export const ParentAdminTableHeader: React.FC = () => {
  const { control, watch, setValue } = useFormContext();

  const { indeterminate } =
    useCookbookSelectAllCheckbox<ParentAdminTableFormProps>({
      selectAllKey: 'selectAll',
      selectedItemsKey: 'selectedParentAdminIds',
      selectableItemsKey: 'selectableParentAdminIds',
      formMethods: { watch, setValue },
    });

  return (
    <Flex alignItems="center">
      <Flex alignItems="center" flexGrow={0}>
        <ParentAdminTableHeaderCell>
          <Flex
            alignItems="center"
            flexGrow={0}
            className="cancelMarginCheckboxLabel"
          >
            <DeprecatedCookbookCheckboxWrapper
              control={control}
              name="selectAll"
              id="selectAll"
              aria-label="Select all parent admins"
              indeterminate={indeterminate}
            />
          </Flex>
        </ParentAdminTableHeaderCell>
      </Flex>

      <Box flex={1}>
        <Row>
          <Column tablet={6}>
            <ParentAdminTableHeaderCell>
              <Copy
                variant="body"
                color="secondaryText"
                className="ellipsisOverflow"
              >
                Parent admin name
              </Copy>
            </ParentAdminTableHeaderCell>
          </Column>
          <Column tablet={6}>
            <ParentAdminTableHeaderCell>
              <Copy
                variant="body"
                color="secondaryText"
                className="ellipsisOverflow"
              >
                Email
              </Copy>
            </ParentAdminTableHeaderCell>
          </Column>
        </Row>
      </Box>

      <Square inset="md" width={120}>
        <Copy variant="body" color="secondaryText">
          Actions
        </Copy>
      </Square>
    </Flex>
  );
};
